var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2029 4581 c-21 -17 -24 -29 -28 -105 l-3 -86 -409 0 c-396 0 -410 -1 -429 -20 -20 -20 -20 -33 -20 -1760 l0 -1740 -285 0 -286 0 -24 -25 c-32 -31 -32 -59 0 -90 l24 -25 716 0 715 0 0 -69 c0 -80 11 -115 39 -131 18 -9 828 76 1748 185 88 10 227 15 446 15 l318 0 24 25 c32 31 32 59 0 90 l-24 25 -286 0 -285 0 0 1734 c0 954 -3 1742 -6 1750 -4 9 -14 21 -24 26 -9 5 -399 52 -866 104 -467 53 -885 100 -928 106 -103 13 -100 13 -127 -9z m956 -226 c462 -52 843 -95 847 -95 5 0 8 -765 8 -1700 0 -935 -4 -1700 -8 -1700 -5 0 -386 -43 -846 -95 -461 -52 -840 -95 -842 -95 -2 0 -4 851 -4 1890 0 1040 1 1890 3 1890 1 0 380 -43 842 -95z m-985 -195 l0 -90 -250 0 c-237 0 -251 -1 -270 -20 -20 -20 -20 -33 -20 -1600 l0 -1580 -90 0 -90 0 0 1690 0 1690 360 0 360 0 0 -90z m0 -1760 l0 -1530 -200 0 -200 0 0 1530 0 1530 200 0 200 0 0 -1530z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2376 2755 c-149 -53 -183 -247 -62 -353 77 -67 185 -67 262 0 99 88 99 228 0 316 -57 50 -128 63 -200 37z m114 -145 c20 -20 26 -65 12 -86 -17 -26 -53 -36 -83 -24 -32 14 -45 45 -35 85 11 44 73 58 106 25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoor);
export default __webpack_public_path__ + "static/media/Door.f9c6813d44e88fb3f0d556bd9b404d71.svg";
export { ForwardRef as ReactComponent };